import * as React from 'react';
import { SolutionOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import './feed-audience-badge.scss';
import { Segment } from '@pushly/models/lib/structs/segment';
export var FeedAudienceBadge = function FeedAudienceBadge(props) {
  var source = props.source,
    appService = props.appService,
    hideTooltip = props.hideTooltip;
  var allDisplay = /*#__PURE__*/React.createElement("span", {
    className: "included-badge"
  }, /*#__PURE__*/React.createElement("span", {
    className: "included-icon"
  }, /*#__PURE__*/React.createElement(SolutionOutlined, null)), /*#__PURE__*/React.createElement("span", null, "All Push Subscribers"));
  var parsedSegments = source.segments.map(function (s) {
    return Segment.parseJsonObject(s);
  });
  var parsedExcludedSegments;
  var isUsingDefaultAll = parsedSegments.length === 1 && parsedSegments[0].isDefault;
  var isUsingExcludedSegments = !!source.excludedSegments && source.excludedSegments.length > 0;
  if (isUsingExcludedSegments) {
    parsedExcludedSegments = source.excludedSegments.map(function (s) {
      return Segment.parseJsonObject(s);
    });
  }
  var badgeSet = allDisplay;
  if (!isUsingDefaultAll || isUsingExcludedSegments) {
    var segments = (parsedSegments || []).slice();
    var excluded_segments = (parsedExcludedSegments || []).slice();
    var nonDefaultSegments = isUsingDefaultAll ? segments : segments.filter(function (s) {
      return !s.isDefault;
    });
    var includedBadge;
    var excludedBadge;
    if (nonDefaultSegments.length > 0) {
      includedBadge = isUsingDefaultAll ? allDisplay : /*#__PURE__*/React.createElement("span", {
        className: "included-badge"
      }, /*#__PURE__*/React.createElement("span", {
        className: "included-icon"
      }, /*#__PURE__*/React.createElement(SolutionOutlined, null)), /*#__PURE__*/React.createElement("span", null, nonDefaultSegments.length), /*#__PURE__*/React.createElement("span", null, "Included"));
    }
    if (excluded_segments.length > 0) {
      excludedBadge = /*#__PURE__*/React.createElement("span", {
        className: "excluded-badge"
      }, /*#__PURE__*/React.createElement("span", {
        className: "excluded-icon"
      }, /*#__PURE__*/React.createElement(SolutionOutlined, null)), /*#__PURE__*/React.createElement("span", null, excluded_segments.length), /*#__PURE__*/React.createElement("span", null, "Excluded"));
    }
    badgeSet = /*#__PURE__*/React.createElement(React.Fragment, null, !!includedBadge && (isUsingDefaultAll || hideTooltip ? includedBadge : /*#__PURE__*/React.createElement(Popover, {
      getPopupContainer: function getPopupContainer() {
        return appService.getAppContainer();
      },
      overlayClassName: "nd-excluded-popover",
      title: "Included Segments",
      content: nonDefaultSegments.map(function (s) {
        return /*#__PURE__*/React.createElement("div", {
          key: s.id
        }, /*#__PURE__*/React.createElement("div", null, /^all$/i.test(s.name) ? 'All Subscribers' : s.name));
      })
    }, includedBadge)), !!excludedBadge && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "details-divider"
    }, "|"), hideTooltip ? excludedBadge : /*#__PURE__*/React.createElement(Popover, {
      getPopupContainer: function getPopupContainer() {
        return appService.getAppContainer();
      },
      overlayClassName: "nd-excluded-popover",
      title: "Excluded Segments",
      content: excluded_segments.map(function (s) {
        return /*#__PURE__*/React.createElement("div", {
          key: s.id
        }, /*#__PURE__*/React.createElement("div", null, s.name));
      })
    }, excludedBadge)));
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "notification-audience-badge"
  }, badgeSet);
};